module.exports = __webpack_public_path__ + "static/image/company/m/visual@3x.jpg?d4bc5712";